module.exports = __webpack_public_path__ + "static/media/old2.36d46fd4.jpeg";